import './AgentChatHistorySkeletonLoader.scss';

const AgentChatHistorySkeletonLoader = () => {
  return (
    <div className="agentChatHistorySkeletonLoader">
      {[0, 1, 2, 3, 4].map(index => (
        <div key={`historySkeletonItem${index}`} className="historySkeletonItem">
          <div className="messageContentSkeleton">
            <div className="messageTextSkeleton animationLoader" />
            <div className="arrowIconSkeleton animationLoader" />
          </div>
          <div className="messageTimeSkeleton animationLoader" />
        </div>
      ))}
    </div>
  );
};

export default AgentChatHistorySkeletonLoader;
